module.exports = function punctuation() {
  // Original by: Clari (https://github.com/Clari-7744)
  //   example 1: punctuation()
  //   returns 1: "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~"

  return '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~'
}
